import UserListPage from './userListPage';

export default UserListPage;
